import { type IThemeContext } from '@/state/Theme';

/**
 * Injects the color palette into the DOM as CSS variables
 * @param theme The theme to inject
 */
function injectColorPalette(theme: IThemeContext): void {
  const { colorPalette, brandColor } = theme;
  const root = document.documentElement;

  if (root) {
    if (colorPalette) {
      colorPalette.map((color) =>
        root.style.setProperty(`--color-${color.name}`, color.value));
    } else {
      console.warn('No color palette defined in theme');
    }

    if (brandColor) {
      root.style.setProperty('--color-brand', brandColor);
    }
  }
}

export default injectColorPalette;
